// CSS 

//Lib 
import moment from 'moment';

// Api  
import api from '@/api/baseApi';

// Constant
import { SETTINGS_USER_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { regex } from "@/constant/config";

// Extend
import base from '@/scripts/base';

// Component    

// Function  

export default {

  extends: base,

  components: {
  },

  data() {
    var validatePhone = (rule, value, callback) => {
      if (value !== null && value.match(regex.phone)) {
        callback();
      } else {
        callback(new Error(this.$t('register.validationTypePhone')));
      }
    };
    return {
      rules: {
        personalName: [
          {
            required: true,
            message: this.$t('profile.validationRequiredFullName'),
            trigger: "blur"
          },
          {
            max: 255,
            message: this.$t('profile.validationMaxFullName'),
            trigger: ["blur", "change"]
          }
        ],
        businessName: [
          {
            required: true,
            message: this.$t('profile.validationRequiredFullName'),
            trigger: "blur"
          },
          {
            max: 255,
            message: this.$t('profile.validationMaxFullName'),
            trigger: ["blur", "change"]
          }
        ],
        personalPhone: [
          {
            required: true,
            message: this.$t('register.validationrequiredPhone'),
            trigger: "blur"
          },
          { validator: validatePhone, trigger: ["blur", "change"] },
          {
            min: 7,
            message: this.$t('register.validationMinPhone'),
            trigger: ["blur", "change"]
          },
          {
            max: 15,
            message: this.$t('register.validationMaxPhone'),
            trigger: ["blur", "change"]
          }
        ],
        businessPhone: [
          {
            required: true,
            message: this.$t('register.validationrequiredPhone'),
            trigger: "blur"
          },
          { validator: validatePhone, trigger: ["blur", "change"] },
          {
            min: 7,
            message: this.$t('register.validationMinPhone'),
            trigger: ["blur", "change"]
          },
          {
            max: 15,
            message: this.$t('register.validationMaxPhone'),
            trigger: ["blur", "change"]
          }
        ],
        personalAddress: [
          {
            required: true,
            message: this.$t('profile.validationRequiredAddress'),
            trigger: "blur"
          },
          {
            max: 200,
            message: this.$t('profile.validationMaxAddress'),
            trigger: ["blur", "change"]
          }
        ],
        businessAddress: [
          {
            required: true,
            message: this.$t('profile.validationRequiredAddress'),
            trigger: "blur"
          },
          {
            max: 200,
            message: this.$t('profile.validationMaxAddress'),
            trigger: ["blur", "change"]
          }
        ],
        personalTaxCode: [
          {
            required: true,
            message: this.$t('profile.validationRequiredAddress'),
            trigger: "blur"
          },
          {
            max: 20,
            message: this.$t('profile.validationMaxAddress'),
            trigger: ["blur", "change"]
          }
        ],
        businessTaxCode: [
          {
            required: true,
            message: this.$t('profile.validationRequiredAddress'),
            trigger: "blur"
          },
          {
            max: 20,
            message: this.$t('profile.validationMaxAddress'),
            trigger: ["blur", "change"]
          }
        ],
      },

      customerTypeList: {
        personal: 1,
        business: 2,
      },

      request: {},

      disabledSaveChanges: true,
    }
  },

  created() {
    this.getData();
  },

  methods: {

    //#region Invoice and Billing change information
    change() {
      this.disabledSaveChanges = false;
    },
    //#endregion

    //#region Invoice billing ___ View
    getData() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      api.baseRequest(SETTINGS_USER_API.INVOICE_BILLING_SETTINGS_VIEW, null)
        .then((res) => {
          let responsedData = res.data;
          this.request = responsedData;
          this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
        })
        .catch(error => {
          this.processCatchApiRequest(error, this.$t('dialog.requestFailed'))
        });
    },
    //#endregion 

    //#region Invoice billing ___ Modify
    modify() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      setTimeout(() => {
        let data = {
          customerType: this.request.customerType,

          personalName: this.request.personalName,
          personalAddress: this.request.personalAddress,
          personalPhone: this.request.personalPhone,
          personalTaxCode: this.request.personalTaxCode,

          businessName: this.request.businessName,
          businessAddress: this.request.businessAddress,
          businessPhone: this.request.businessPhone,
          businessTaxCode: this.request.businessTaxCode,
          deviceInformation: JSON.stringify(this.getInformationClient())
        }
        api.baseRequest(SETTINGS_USER_API.INVOICE_BILLING_SETTINGS_MODIFY, data)
          .then(() => {
            this.notificationSuccess(this.$t('bootMachine.renewalSuccessTitle'), this.$t('profile.saveSuccessMessage'));
            this.disabledSaveChanges = true;
            this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
          })
          .catch(error => {
            this.processCatchApiRequest(error, this.$t('bootMachine.bootFailed'))
          });
      }, this.smoothTimeOut);
    },
    //#endregion
  },
}